import React, { useState, useEffect } from "react";
import { IonSlides, IonSlide, IonLabel, IonCol, IonRow, IonText } from "@ionic/react";
import * as constants from "../../constants";

interface carModelsProps {
  carModels: Array<any>;
  saveModelData: Function;
  selectedModel: string;
  searchData: string;
  brandName: string;
  handleKeypressModels: Function;
}

const SelectVehicleModel: React.FC<carModelsProps> = ({
  carModels,
  saveModelData,
  selectedModel,
  searchData,
  brandName,
  handleKeypressModels,
}: carModelsProps) => {
  const handleSearch = (data: any, searchData: any) => {
    if (!!searchData) {
      return data.filter((ele: any) => {
        if (ele["name"].trim().toLowerCase().includes(searchData.trim().toLowerCase())) {
          return ele;
        }
      });
    }
    return data;
  };
  return (
    <>
      <IonRow
        className={
          handleSearch(carModels, searchData).length
            ? "brands_div margin-left-right-0"
            : "no-variants-layout margin-left-right-0"
        }
      >
        {handleSearch(carModels, searchData).length ? (
          handleSearch(carModels, searchData).map((ele: any, index: any) => (
            <IonCol
              key={index}
              size-md="6"
              size="12"
              style={{
                height: "auto",
              }}
            >
              <IonRow
                tabIndex={0}
                className={selectedModel === ele.name ? "selected-model-layout" : "model_layout"}
                onKeyPress={(event) =>
                  handleKeypressModels(event, ele.name, ele.imageUrl, ele.modelId)
                }
                onClick={() => saveModelData(ele.name, ele.imageUrl, ele.modelId)}
              >
                <IonCol className="pd_zero">
                  <IonText className="model_text">{ele.make}</IonText>
                  <p className="model_label">{ele.name}</p>
                </IonCol>
                <IonCol className="pd_zero">
                    {!!ele.imageUrl ? <img src={ele.imageUrl} className="model_img" /> : ""}
                </IonCol>
              </IonRow>
            </IonCol>
          ))
        ) : (
          <div>
            <h3 color="secondary">{constants.NO_MODELS_FOUND}</h3>
          </div>
        )}
      </IonRow>
    </>
  );
};

export default SelectVehicleModel;
